import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

interface Permissions {
  [module: string]: string[];
}

export const usePermissions = () => {
  const [permissions, setPermissions] = useState<Permissions>({});

  useEffect(() => {
    loadPermissions();
  }, []);

  const loadPermissions = () => {
    const savedPermissions = localStorage.getItem('permissions');
    if (savedPermissions) {
      setPermissions(JSON.parse(savedPermissions));
    }
  };

  const refreshPermissions = async () => {
    try {
      const data = await apiService.refreshPermissions();
      localStorage.setItem('permissions', JSON.stringify(data.permissoes));
      setPermissions(data.permissoes);
    } catch (error) {
      console.error('Erro ao atualizar permissões:', error);
    }
  };

  const hasPermission = (module: string, action: string): boolean => {
    return permissions[module]?.includes(action) || false;
  };

  const canViewModule = (module: string): boolean => {
    return permissions[module]?.length > 0 || false;
  };

  return {
    hasPermission,
    canViewModule,
    refreshPermissions
  };
};